// @ts-strict-ignore
import { getWiredServerContext, WiredServerContext } from 'relay-nextjs/wired/context'
import { WiredSerializedState } from 'relay-nextjs/wired/serialized_state'
import serialize from 'serialize-javascript' // this is a dependency of relay-nextjs, so we have it
import PageBundlePlaceholder from 'components/PageBundlePlaceholder'
import { ScriptHTMLAttributes } from 'react'
import { GraphQLTaggedNode } from 'relay-runtime'
import { getClientEnvironment } from 'api/graphql/relay/clientEnvironment'
import { NavigationWrapperQuery } from 'components/Layout/components/NavigationWrapper'
import { createServerEnvironmentFromCtx } from 'services/relay'
import { Wire as withRelayOriginal, WiredOptions, WiredProps } from 'relay-nextjs/wired/component'

// This function is copied from https://github.com/RevereCRE/relay-nextjs/blob/main/src/wired/document.tsx version 1.0.1
// The reason we don't just import it is that it must be customized for working with Material-UI
export function createRelayDocument(): any { // TODO: types
  let capturedWiredContext: WiredServerContext | undefined

  // Here we customize by adding an emotionCache parameter
  const enhance = (App) => {
    return function EnhancedApp(props: any) {
      // Here we customize the source of the wired server context to make the withLayout hook work
      const pageProps = (props as any)?.initialProps?.pageProps || (props as any)?.pageProps
      // Here we add this "if" condition to prevent a crash when the pageProps are undefined
      if (pageProps?.__wired__server__context) {
        capturedWiredContext = getWiredServerContext(
          pageProps.__wired__server__context,
        )
        // console.log('Captured wired context', Boolean(capturedWiredContext))
      } else {
        // console.log('Did not capture wire context', props)
      }

      // console.log('Collecting Sheets')
      return <App {...props} />
    }
  }

  const Script = (props: ScriptHTMLAttributes<HTMLScriptElement>) => {
    if (capturedWiredContext == null) {
      // console.log('Did not find wired context', props)
      return null
    }

    const serializedState: WiredSerializedState = {
      operationDescriptor: capturedWiredContext.operationDescriptor,
      payload: capturedWiredContext.payload,
    }

    // console.log('Found wired context', serializedState)

    return (
      <script
        dangerouslySetInnerHTML={{
          __html: `window.__wired__=${serialize(serializedState)}`,
        }}
        {...props}
      />
    )
  }

  return { enhance, Script }
}

export type WithRelayOptions<Props extends WiredProps, ServerSideProps> = Omit<
  WiredOptions<Props, ServerSideProps>,
  'createClientEnvironment' | 'createServerEnvironment'
>

/**
 * Sets up the Relay integration, optionally with a query to preload that the page will be able to use.
 * This is required for all pages to use, for the app to work correctly.
 *
 * TODO: rename this to withRelay
 *
 * @param Component the component to render
 * @param query (optional) the query to pre-load for the component
 * @param opts other options, such as conditional server side redirects and specifying variables for the query
 */
export default function withPreloadedQuery<Props extends WiredProps, ServerSideProps = {}>(
  // TODO: Use ComponentType<Props> for the type of PageComponent. Figure out why it causes type errors
  Component: any,
  query: GraphQLTaggedNode = NavigationWrapperQuery,
  opts: WithRelayOptions<Props, ServerSideProps> = {},
) {
  return withRelayOriginal(
    Component,
    query,
    {
      createClientEnvironment: getClientEnvironment,
      createServerEnvironment: createServerEnvironmentFromCtx,
      fallback: <PageBundlePlaceholder />,
      ...opts,
    },
  )
}
